import { render } from "./PostProgramRecidivismReport.vue?vue&type=template&id=9e6874bc&ts=true"
import script from "./PostProgramRecidivismReport.vue?vue&type=script&lang=ts"
export * from "./PostProgramRecidivismReport.vue?vue&type=script&lang=ts"

import "./PostProgramRecidivismReport.vue?vue&type=style&index=0&id=9e6874bc&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__